import React from 'react';

const VernamCipherAlgo = () => {
    return (
        <div>
            <h3>Encryption:</h3>
            <ol>
                <li>Take the plaintext message you want to encrypt.</li>
                <li>Write the positions of each character in plaintext</li>
                <li>Choose a key. If key size if smaller than plaintext, repeat the key to make it same size as plaintext</li>
                <li>Write the positions of each character in the key</li>
                <li>For each character in the plaintext:
                    <ol type='a' style={{ marginLeft: 30 }}>
                        <li>Add plaintext position and key position.</li>
                        <li>Take 'mod 26' of the resultant value.</li>
                        <li>Convert the result back to a character.</li>
                        <li>Append the resulting character to the ciphertext.</li>
                    </ol>
                </li>
                <li>The resulting ciphertext is the encrypted message.</li>
            </ol>
            <br />
            <h3>Decryption:</h3>
            <ol>
                <li>Take the cipher message you want to decrypt.</li>
                <li>Write the positions of each character in ciphertext</li>
                <li>Choose the same key used for encryption. If key size if smaller than cipher, repeat the key to make it same size as ciphertext</li>
                <li>Write the positions of each character in the key</li>
                <li>For each character in the ciphertext:
                    <ol type='a' style={{ marginLeft: 30 }}>
                        <li>Subtract the key position from ciphertext position</li>
                        <li>If the result is Negative, add 26 to it.</li>
                        <li>Convert the result back to a character.</li>
                        <li>Append the resulting character to the plaintext.</li>
                    </ol>
                </li>
                <li>The resulting plaintext is the decrypted message.</li>
            </ol>
        </div>
    );
}

export default VernamCipherAlgo;
